import styled from 'styled-components';
import { List } from '@bynder/design-system';

export const StyledListItem = styled(List.Item)`
    div > div > span {
        white-space: unset;
    }
`;
